/* ═══════════════════════════════════════════
   BAU BUNDLE — Product Registry v2.5
   + Front D-Ring automatico
   + Completa i prodotti mancanti via /products/*.js anche con inline data
   ═══════════════════════════════════════════ */
(function () {
  'use strict';

  var BauBundleProducts = {
    BUNDLE_CONFIG: {
      paid: ['pettorina', 'guinzaglio', 'guinzaglio_large'],
      free: ['ebook', 'front_d_ring', 'portabustine']
    },

    products: {},
    ready: false,
    _loadPromise: null,

    _handles: function () {
      var h = window.__BAU_BUNDLE_HANDLES__ || {};
      return {
        pettorina:         h.pettorina         || 'pettorina-personalizzata-cane',
        guinzaglio:        h.guinzaglio        || 'guinzaglio-riflettente-per-cani',
        guinzaglio_large:  h.guinzaglio_large  || 'guinzaglio-baugrip',
        portabustine:      h.portabustine      || 'portabustine-led-per-cani',
        portabustine_free: h.portabustine_free || 'portabustine-led-luminoso-gratuito',
        ebook:             h.ebook             || 'baubook-uscita-perfetta-gratuito',
        front_d_ring:      h.front_d_ring      || 'aggancio-frontale-gratuito'
      };
    },

    init: function () {
      if (this._loadPromise) return this._loadPromise;
      var self = this;

      this._loadPromise = Promise.resolve()
        .then(function () {
          if (window.__BAU_BUNDLE_DATA__) self._parseInlineData(window.__BAU_BUNDLE_DATA__);
          return self._loadMissingProducts();
        })
        .then(function () {
          self.ready = true;
          window.dispatchEvent(new CustomEvent('bau-bundle:products-ready', {
            detail: { products: self.products }
          }));
          return self.products;
        });

      return this._loadPromise;
    },

    _parseInlineData: function (data) {
      var self = this;
      Object.keys(data || {}).forEach(function (key) {
        var d = data[key];
        if (!d) return;
        self.products[key] = {
          id: d.id,
          title: d.title,
          handle: d.handle,
          featuredImage: d.featured_image,
          images: d.images || [],
          variants: (d.variants || []).map(function (v) {
            return {
              id: v.id,
              title: v.title,
              option1: v.option1,
              option2: v.option2,
              option3: v.option3,
              price: Number(v.price || 0) / 100,
              compareAtPrice: v.compare_at_price ? Number(v.compare_at_price) / 100 : null,
              available: v.available !== false,
              image: v.featured_image ? v.featured_image.src : d.featured_image,
              sku: v.sku
            };
          }),
          options: d.options || []
        };
      });
    },

    _loadMissingProducts: async function () {
      var self = this;
      var handles = this._handles();
      var entries = Object.entries(handles).filter(function (entry) {
        return !self.products[entry[0]];
      });
      if (!entries.length) return;

      var results = await Promise.allSettled(entries.map(function (entry) {
        return self._fetchProduct(entry[0], entry[1]);
      }));
      results.forEach(function (result, i) {
        if (result.status === 'rejected') {
          console.error('[BauBundle] ❌ Failed:', entries[i][0], entries[i][1], result.reason);
        }
      });
    },

    async _fetchProduct(key, handle) {
      var response = await fetch('/products/' + handle + '.js', {
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      if (!response.ok) throw new Error('HTTP ' + response.status + ' for ' + handle);
      var data = await response.json();
      this._parseInlineData({ [key]: data });
    },

    getProduct: function (key) { return this.products[key] || null; },

    getVariants: function (key) {
      var product = this.products[key];
      if (!product) return [];
      return product.variants.filter(function (v) { return v.available; });
    },

    findVariant: function (key, opts) {
      opts = opts || {};
      var variants = this.getVariants(key);
      return variants.find(function (v) {
        var match = true;
        if (opts.color) match = match && v.option1 && v.option1.toLowerCase().trim() === opts.color.toLowerCase().trim();
        if (opts.size)  match = match && v.option2 && v.option2.toLowerCase().trim() === opts.size.toLowerCase().trim();
        return match;
      }) || null;
    },

    findFreeVariant: function (color, size) {
      var freeVariants = this.getVariants('portabustine_free');
      if (!freeVariants.length) return null;
      var match = freeVariants.find(function (v) {
        var colorMatch = !color || (v.option1 && v.option1.toLowerCase().trim() === color.toLowerCase().trim());
        var sizeMatch  = !size  || (v.option2 && v.option2.toLowerCase().trim() === size.toLowerCase().trim());
        return colorMatch && sizeMatch;
      });
      if (!match && color) {
        match = freeVariants.find(function (v) {
          return v.option1 && v.option1.toLowerCase().trim() === color.toLowerCase().trim();
        });
      }
      return match || freeVariants[0] || null;
    },

    getColors: function (key) {
      var variants = this.getVariants(key);
      var colors = new Map();
      variants.forEach(function (v) {
        if (v.option1 && !colors.has(v.option1)) colors.set(v.option1, { name: v.option1, image: v.image });
      });
      return Array.from(colors.values());
    },

    getSizesForColor: function (key, color) {
      var variants = this.getVariants(key);
      return variants
        .filter(function (v) { return v.option1 && v.option1.toLowerCase().trim() === color.toLowerCase().trim(); })
        .map(function (v) {
          return { size: v.option2, price: v.price, compareAtPrice: v.compareAtPrice, variantId: v.id, available: v.available };
        });
    },

    getDefaultVariant: function (key) { return this.getVariants(key)[0] || null; },
    isReady: function () { return this.ready; }
  };

  window.BauBundleProducts = BauBundleProducts;
})();
